<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E7OdvC/tc-custom/9780226187396.jpg?1733027516333" alt="This image is the cover for the book Dandyism in the Age of Revolution"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dandyism in the Age of Revolution
      </h1>
      <p class="bookDescription body article font2">
        <p>From the color of a politician’s tie, to exorbitantly costly haircuts, to the size of an American flag pin adorning a lapel, it’s no secret that style has political meaning. And there was no time in history when the politics of fashion was more fraught than during the French Revolution. In the 1790s almost any article of clothing could be scrutinized for evidence of one’s political affiliation. A waistcoat with seventeen buttons, for example, could be a sign of counterrevolution—a reference to Louis XVII—and earn its wearer a trip to the guillotine.<br/><br/> In <i>Dandyism in the Age of Revolution</i>, Elizabeth Amann shows that in France, England, and Spain, daring dress became a way of taking a stance toward the social and political upheaval of the period. France is the centerpiece of the story, not just because of the significance of the Revolution but also because of the speed with which its politics and fashions shifted. Dandyism in France represented an attempt to recover a political center after the extremism of the Terror, while in England and Spain it offered a way to reflect upon the turmoil across the Channel and Pyrenees. From the Hair Powder Act, which required users of the product to purchase a permit, to the political implications of the feather in Yankee Doodle’s hat, Amann aims to revise our understanding of the origins of modern dandyism and to recover the political context from which it emerged.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Amann
      </h2>
      
      <p class="authorDescription body article"><B>Elizabeth Amann</B> is professor in the Department of Literary Studies at Ghent University, Belgium. She is the author of <I>Importing Madame Bovary: The Politics of Adultery.&#160;</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a99f596